import { SortOrder } from "@arelia-types/data-models"
import { PublishingRoyaltyDetail } from "../models"

export enum RoyaltiesEarningsSorting {
  amountEarnedAsc = "amountEarnedAsc",
  amountEarnedDesc = "amountEarnedDesc",
}

export type SortOrderMap = {
  [key in RoyaltiesEarningsSorting]: SortOrder;
}

export type SortValueGetterMap = {
  [key in RoyaltiesEarningsSorting]: (customer: PublishingRoyaltyDetail) => number;
}